$(document).ready(function (e) {
  if (
    ($("body").on("change", ".filter_check", function (e) {
      e.preventDefault(), (window.location = $(this).parent().find("a").attr("href"));
    }),
      $(".shopify-currency-form select").on("change", function () {
        $(this).parents("form").submit();
      }),
      $(".currecyBox").niceSelect(),
      (Shopify.queryParams = {}),
      location.search.length)
  );
});
